import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-1of1 gfu-1of2--s gfu-1of3--m" }
const _hoisted_2 = ["href", "data-qa"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      class: "gfu-btn gfu-btn--primary gfu-btn--soft gfu-btn--block",
      href: $props.actionUrl,
      "data-qa": $props.qa
    }, [
      _createElementVNode("span", null, _toDisplayString($options.buttonText), 1 /* TEXT */)
    ], 8 /* PROPS */, _hoisted_2)
  ]))
}